import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appEmailInputRestrictor]'
})
export class EmailInputRestrictorDirective {

  @HostListener('input', ['$event']) onInput(event: any): void {
    const input = event.target as HTMLInputElement;
    const inputValue = input.value;
    
    // Remove any characters that are not allowed in an email
    const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9@._-]/g, '');
    
    if (inputValue !== sanitizedValue) {
      input.value = sanitizedValue;
      event.preventDefault();
    }
  }
}
